import { SecretTemplateModel } from '@/adapters/apiv1.g';
import type { SecretTemplate } from '@/types/core/secret-template';
import type { UUID } from '@/utils/uuid';

/**
 * Transform a backend secret template response to a frontend SecretTemplate type.
 * @param data - API secret template response
 * @returns SecretTemplate - UI-friendly SecretTemplate object
 */

export function extractSecretTemplate(
  data: SecretTemplateModel
): SecretTemplate {
  // The API stores schema as a JSON string; parse it so UI code can read .properties etc.
  let schema: SecretTemplate['schema'] | undefined;
  if (data?.schema) {
    if (typeof data.schema === 'string') {
      try {
        schema = JSON.parse(data.schema) as SecretTemplate['schema'];
      } catch {
        schema = undefined;
      }
    } else {
      schema = data.schema as SecretTemplate['schema'];
    }
  }

  return {
    _rev: data?._rev,
    templateId: (data?.template_id ?? '') as UUID,
    name: data?.name ?? '',
    description: data?.description ?? '',
    schema,
    status: data?.status ?? '',
    readOnly: data?.read_only ?? false,
  };
}
